import {axios} from '../utils/axios'

export function getnews(data){
  return axios({
    url: "/getThemListByDict",
    method: 'get',
    params: data,
  })
}
export function getmsg(data){
  return axios({
    url: "/msb/getUserInfo",
    method: 'get',
    params: data,
  })
}
export function getNotice(data){
  return axios({
    url: "/api/new/getNotice",
    method: 'get',
    params: data,
  })
}
export function getNotice2(data){
  return axios({
    url: "/new/getNotice2",
    method: 'get',
    params: data,
  })
}
export function getNotice2detail(data){
  return axios({
    url: "/getNoticeDetail2",
    method: 'get',
    params: data,
  })
}
export function getEexpress(data){
  return axios({
    url: "/getEexpress",
    method: 'get',
    params: data,
  })
}

export function getEexpressDetail(data){
  return axios({
    url: "/getEexpressDetail",
    method: 'get',
    params: data,
  })
}

export function getPcBanner2(data){
  return axios({
    url: "/getPcBanner2",
    method: 'get',
    params: data,
  })
}
export function getPolicyEconomy(data){
  return axios({
    url: "/getPolicyEconomy",
    method: 'get',
    params: data,
  })
}
export function getPolicyEconomyDetail(data){
  return axios({
    url: "/getPolicyEconomyDetail",
    method: 'get',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js